// extracted by mini-css-extract-plugin
export default {"container":"ConfirmationPage_container__T3k+F"};